import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-shopping-sale1-icon',
  templateUrl: './shopping-sale1.component.html'
})
export class ShoppingSale1Component extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
